import { api } from 'services/api';

export class EmailSendingService {
  async listConfigs() {
    return api.get('/email-sending-configs');
  }

  async getConfigById(id) {
    return api.get(`/email-sending-configs/${id}`);
  }

  async createConfig(formData) {
    return api.post('/email-sending-configs', formData);
  }

  async updateConfig(id, formData) {
    return api.put(`/email-sending-configs/${id}`, formData);
  }

  async deleteConfig(id) {
    return api.delete(`/email-sending-configs/${id}`);
  }

  async sendNow(id) {
    return api.post(`/email-sending-configs/${id}/send-now`);
  }

  async listLogs(id) {
    return api.get(`/email-sending-configs/${id}/logs`);
  }
}

export const emailSendingService = new EmailSendingService();
